import { render, staticRenderFns } from "./VCardHeader.vue?vue&type=template&id=568575ea&"
import script from "./VCardHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VCardHeader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VCardHeader.vue?vue&type=style&index=0&id=568575ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports